import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactTable  from "react-table";
import {getToken, getUserSettings, setLocalKeyValue, getLocalKeyValue} from '../../storage'
import {ITEM_LIST_PAGE_SIZE} from '../../constants'
import SearchInput from '../search/search'
import _ from 'lodash'
import {updateHistory} from '../commons/functions'

class StockFooter extends React.Component {
  render() {

    let data = this.props.data

    if(data.length > 0) {
      let total = _.sum(_.map(data, d=>{

        let quantity = parseFloat(d.closing_stock)
        let closing_purchase_basic_rate = parseFloat(d.closing_purchase_basic_rate)
        return quantity * closing_purchase_basic_rate
      }))

      total = parseFloat(total).toFixed(2)

      return <div className="text-right">
        {total}
        <div>
          {this.props.entire_stock_value}
        </div>
      </div>
    }
    else {
      return null
    }

  }
}

class StockFooterWithTax extends React.Component {
  render() {

    let data = this.props.data

    if(data.length > 0) {
      let total = _.sum(_.map(data, d=>{

        let quantity = parseFloat(d.closing_stock)
        let closing_purchase_basic_rate = parseFloat(d.closing_purchase_basic_rate)
        if(d.gst) {
          if(d.gst['igst']) {
            return quantity * closing_purchase_basic_rate * (100+ parseFloat(d.gst['igst']))/100
          }
        }
        return quantity * closing_purchase_basic_rate
      }))

      total = parseFloat(total).toFixed(2)

      return <div className="text-right">
        {total}
        <div>
          {this.props.entire_stock_value}
        </div>
      </div>
    }
    else {
      return null
    }

  }
}

class ItemExtended extends React.Component {

  render() {

    const option = this.props.option
    const name = option.name
    var stock = option.closing_stock
    if(typeof option.className !== "undefined" && option.className !== null) {
      return name
    }
    else {
      let suffix

      const unit = option.unit
      if(typeof unit !== "undefined" && unit !== null) {

        if(typeof unit.container_unit !== "undefined" && unit.container_unit !== null && unit.container_unit.length > 0) {

          const containers = parseInt(parseFloat(stock)/parseFloat(unit.container_volume), 10)

          const remaining_primary_units = stock - (containers * unit.container_volume)

          suffix = <span>{containers +" "+ unit.container_unit + " "+remaining_primary_units + " "+unit.primary_unit}</span>

        }
        else {
          suffix =  <span>{Number(stock)+" "+ unit.primary_unit}</span>
        }
      }
      else {
        suffix = <span></span>
      }

      if (parseFloat(stock) <= 0) {
        suffix = <span className="text-danger">{suffix}</span>
      }
      else {
        suffix = <span className="">{suffix}</span>
      }

      return <span>{suffix}</span>
    }

  }
}

function stockValueWithTax(row) {

    let quantity = parseFloat(row.original.closing_stock)
    let closing_purchase_basic_rate = parseFloat(row.original.closing_purchase_basic_rate)
    let igst
    if(row.original.gst && row.original.gst['igst']) {
      igst = 100 + parseFloat(row.original.gst['igst'])
      return parseFloat(quantity * closing_purchase_basic_rate * igst/100).toFixed(2)
    }
    else {
      return parseFloat(quantity * closing_purchase_basic_rate).toFixed(2)
    }


}
function stockValue(row) {

  let quantity = parseFloat(row.original.closing_stock)
  let closing_purchase_basic_rate = parseFloat(row.original.closing_purchase_basic_rate)
  return parseFloat(quantity * closing_purchase_basic_rate).toFixed(2)
}

export default class ItemList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: null,
      loading: true,
      brand: props.location.state ? (props.location.state.brand || null): null,
      query: props.location.state ? (props.location.state.query || null): null,
      serial_search: props.location.state ? (props.location.state.serial_search || null): null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreate = this.goToCreate.bind(this)
    this.handleSearchInput = this.handleSearchInput.bind(this)
    this.handleSearchSerial = this.handleSearchSerial.bind(this)
    document.title = "Items List"
  }


  downloadReport = (report_type) => {
    return   axios({
      url: report_type,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  downloadClients = () => {


    let apiurl = "/export_items_excel/?";

    if(this.state.brand){
      apiurl = apiurl + '&brand_id='+this.state.brand.id
    }

    if(this.state.query) {
      apiurl = apiurl + '&q='+ this.state.query
    }

    this.downloadReport(apiurl).then((response)=> {


      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {

      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  handleSearchSerial(serial) {
    this.fetchData(this.state.tableState, {}, this.state.query, serial)
    updateHistory(this.props, {serial_search:serial})
  }

  handleBrandChange = (value)=>{
    this.setState({brand: value})
    this.fetchData(this.state.tableState, {}, this.state.query, this.state.serial, value)
    updateHistory(this.props, {brand:value})
  }

  handleSearchInput(q) {
    this.fetchData(this.state.tableState, {}, q)
    updateHistory(this.props, {query:q})
  }
  goToCreate(e) {
    e.preventDefault()
    this.props.history.push("/items/create/")
  }

  getBrands =()=> {
    let apiurl = "/list_brands/?sort_column=name&sort_dir=asc";
   return  axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
        return {options: res.data.brands}
      // this.setState({
      //   brands: res.data.brands
      // });
    });
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/items/edit/'+row.original.serial)
      },
      style: {
        cursor:'pointer'
      }
    }
  }


    fetchData(state, instance, query=this.state.query, serial=this.state.serial_search, brand=this.state.brand) {

      let settings = getUserSettings()

      let options
      if(settings && settings.options) {
        options = settings.options
      }

      this.setState({ loading: true });
      setLocalKeyValue(ITEM_LIST_PAGE_SIZE, state.pageSize)
      let apiurl = "/list_items/?stock_info=yes&item_type=item&page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }



      if(query) {
        apiurl = apiurl + '&q='+ query
      }
      if(serial) {
        apiurl = apiurl + '&serial='+serial
      }
      if(options && options.item_table_stock_with_tax) {
        apiurl = apiurl + '&stock_with_tax=true'
      }
      if(typeof brand !== "undefined" && brand !== null) {
        apiurl = apiurl + '&brand_id='+brand.id
      }
      this.setState({tableState:state, query:query, brand:brand})
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.items,
          pages: res.data.pages,
          entire_stock_value:res.data.entire_stock_value.v__sum,
          entire_stock_value_with_tax: res.data.entire_stock_value_with_tax.vt__sum,
          loading: false
        });
      });
    }


    renderClosingPurchaseRate(row) {
      let cn = "", ttl

      if(parseFloat(row.original.closing_purchase_basic_rate) > parseFloat(row.original.selling_basic_rate)) {
        cn = "text-danger"
        ttl = "Purchase rate is higher than selling rate"
      }
      if(ttl) {
        return <div className={"text-right " + cn} title={ttl}>{Number(row.original.closing_purchase_basic_rate)}</div>
      }
      return <div className={"text-right " + cn} >{Number(row.original.closing_purchase_basic_rate)}</div>
    }


    render() {


      let settings = getUserSettings(), is_item_batches = false, show_code = false, serial_search
      if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
          is_item_batches = true
      }

      if(typeof settings !== "undefined" && settings != null && settings.invoice_barcode_entry) {
        show_code = true
        serial_search = <div className="col-sm-2 mtop hidden-print">
              <SearchInput value={this.state.serial_search} handleSearchInput={this.handleSearchSerial} placeholder={"Search Serial"} />
        </div>
      }


      let options
      if(settings && settings.options) {
        options = settings.options
      }

      let entire_stock_value, entire_stock_value_with_tax
      if(this.state.entire_stock_value) {
        entire_stock_value = parseFloat(this.state.entire_stock_value).toFixed(2)
      }
      if(this.state.entire_stock_value_with_tax) {
        entire_stock_value_with_tax = parseFloat(this.state.entire_stock_value_with_tax).toFixed(2)
      }
      const { data, pages, loading } = this.state;
      let columns = []

      if(show_code) {
        columns.push({Header:'Serial', accessor:'serial', sortable:true})
      }

      columns.push({Header:'Brand', accessor: 'brand.name', sortable:false })
      columns.push({Header:'Item', accessor: 'name',sortable:true })

      if (!is_item_batches) {
        columns.push({Header:'Current Stock', accessor: 'closing_stock', sortable:true, Cell:(row)=>(<ItemExtended option={row.original} />)})
        columns.push({Header:'Closing Purchase Rate', accessor:'closing_purchase_basic_rate', sortable:true, Cell:(row)=>(<div className="text-right">{this.renderClosingPurchaseRate(row)}</div>)})
        columns.push({Header: 'Stock Value', sortable:false,
          Cell:(row)=>(<div className="text-right">{ stockValue(row)}</div>), Footer:(<StockFooter data={data} entire_stock_value={entire_stock_value} />)

      })
      if(options && options.item_table_stock_with_tax === true) {
        columns.push({Header: 'Stock Value With Tax', sortable:true,
          Cell:(row)=>(<div className="text-right">{ stockValueWithTax(row)}</div>), Footer:(<StockFooterWithTax data={data} entire_stock_value={entire_stock_value_with_tax} />)
        })
      }



      }

      if(options && options.created_and_modified_user_info) {
        columns.push({Header:'Created By', Cell:(row)=>(<div className="text-center">{ row.original.created_by ? row.original.created_by.username: ""}</div>)})
        columns.push({Header:'Modified By', Cell:(row)=>(<div className="text-center">{ row.original.modified_by ? row.original.modified_by.username: ""}</div>)})
      }

      const defaultSort=[{id: "serial", desc: true}]
      let pageSize = getLocalKeyValue(ITEM_LIST_PAGE_SIZE)

      if(typeof pageSize === "undefined"){
        pageSize = 20
      }
      else {
        pageSize = parseInt(pageSize, 10)
      }
      return <div><section className="medium hidden-print">
        <div className="row">
          <div className="col-sm-2">
          <button onClick={this.goToCreate} className="btn btn-primary">Create New Item</button>
          </div>

          <div className="col-sm-3 mtop">
                <SearchInput value={this.state.query} handleSearchInput={this.handleSearchInput} placeholder={"Search Items"} />
          </div>
          {serial_search}
          <div className="col-sm-3 mtop">
            <Select.Async multi={false} onChange={this.handleBrandChange}
            value={this.state.brand} valueKey="id" labelKey="name"
            loadOptions={this.getBrands} backspaceRemoves={true} placeholder="Select Brand"/>
          </div>
        </div>

      </section>
      <div className="row">
        <div className="col-sm-12">


        <div className="row">

            <div className="col-xs-12">
              <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadClients()}}>Download xls</button></div>
            </div>
        </div>

          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Items Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={pageSize}  />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/item/itemlist.js